import React, { useEffect, useState } from 'react'
import { StickyContainer } from '@/common/sticky'

import styles from './index.module.less'
import Header from './components/Header'
import Content from './components/Content'

const PoizonBrandPromotion = (props: any) => {
  console.info('PoizonBrandPromotion props', props)
  const { tabList = [] } = props.propsConfig
  const [activeTab, setActiveTab] = useState(0)
  console.info('PoizonBrandPromotion tabList', tabList)
  const tabNames = tabList.map((item) => item.tabName)
  const tabPageLists = tabList.map((item) => item.pageList)

  useEffect(() => {
    scrollTo(0, 0)
  }, [activeTab])

  return (
    <div className={styles.tabWrapper}>
      <StickyContainer>
        <Header activeTab={activeTab} setActiveTab={setActiveTab} tabNames={tabNames} />
        <Content activeTab={activeTab} setActiveTab={setActiveTab} tabPageLists={tabPageLists} />
      </StickyContainer>
    </div>
  )
}

PoizonBrandPromotion.config = {
  name: 'poizon-brand-promotion',
}

export default PoizonBrandPromotion
